import clientsApi from '@/api/v1/clients';

export default {
  namespaced: true,

  state: {
    issue: {
      id: '',
      title: '',
      status: '',
      post_date: '',
      project_name: '',
      client_name: '',
      client_company_name: '',
      developer_name: '',
      developer_roles: [],
      messages: [],
    },

    isDataLoading: false,
    isSubmitProcessing: false,
  },

  mutations: {
    CHANGE_ISSUE(state, issueData) {
      state.issue = { ...issueData };
    },

    CHANGE_LOADING_STATUS(state, status) {
      state.isDataLoading = status;
    },

    CHANGE_SUBMIT_STATUS(state, status) {
      state.isSubmitProcessing = status;
    },
  },

  actions: {
    fetchIssue({ commit }, issueId) {
      commit('CHANGE_LOADING_STATUS', true);

      return new Promise((resolve, reject) => {
        clientsApi.issues
          .show(issueId)
          .then((resp) => {
            commit('CHANGE_ISSUE', resp.data);
            resolve();
          })
          .catch(() => {
            reject();
          })
          .finally(() => {
            commit('CHANGE_LOADING_STATUS', false);
          });
      });
    },

    createIssue({ commit, dispatch }, issueData) {
      commit('CHANGE_LOADING_STATUS', true);

      return new Promise((resolve, reject) => {
        clientsApi.issues
          .create(issueData)
          .then((resp) => {
            dispatch('showSuccess', ['Issue submited'], { root: true });
            resolve(resp);
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          })
          .finally(() => {
            commit('CHANGE_LOADING_STATUS', false);
          });
      });
    },

    submitIssueMessage({ commit, dispatch }, issueData) {
      commit('CHANGE_SUBMIT_STATUS', true);

      return new Promise((resolve, reject) => {
        clientsApi.issues
          .reply(issueData.id, issueData.message)
          .then((resp) => {
            dispatch('showSuccess', ['Message sent'], { root: true });
            commit('CHANGE_ISSUE', resp.data);
            resolve(resp);
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          })
          .finally(() => {
            commit('CHANGE_SUBMIT_STATUS', false);
          });
      });
    },
  },
};
